module.exports = __webpack_public_path__ + "img/beat.73820591.png";